'use client';

import { useContext } from 'react';
import { AskModalContext } from './Context';

export const useOpenAskModal = () => {
	const context = useContext(AskModalContext);
	if (context === undefined) {
		throw new Error(
			'useAskModalContext must be used within an AskModalProvider',
		);
	}
	return context;
};
